"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OsOpenNames = void 0;
var GazetteerBase_1 = require("../GazetteerBase");
var GazetteerSearchType_1 = require("../GazetteerSearchType");
var olProj = require("ol/proj");
var olExtent = require("ol/extent");
var Style_1 = require("ol/style/Style");
var Text_1 = require("ol/style/Text");
var Fill_1 = require("ol/style/Fill");
var OsOpenNames = /** @class */ (function (_super) {
    __extends(OsOpenNames, _super);
    function OsOpenNames(_map, _apikey, _textPack, _zoomToLevel, _elementId, _btnCssClass, _iconCssClass, _clearerCssClass) {
        if (_zoomToLevel === void 0) { _zoomToLevel = 17; }
        if (_elementId === void 0) { _elementId = "gazetteer"; }
        if (_btnCssClass === void 0) { _btnCssClass = "btn btn-primary"; }
        if (_iconCssClass === void 0) { _iconCssClass = "fa fa-search"; }
        if (_clearerCssClass === void 0) { _clearerCssClass = "fa fa-times"; }
        var _this = _super.call(this, _map, _textPack, _apikey, _elementId, _btnCssClass, _iconCssClass, _clearerCssClass) || this;
        _this._zoomToLevel = _zoomToLevel;
        _this._osInitialised = false;
        _this._currentSearchTerm = "";
        _this._osNamesUrl = "https://api.os.uk/search/names/v1/find";
        _this.init = function () {
            if (!_this._osInitialised) {
                _this._mapBounds = olProj.transformExtent(_this._map.options.extent, _this._map.options.displayProjection, "EPSG:27700");
                //strip-loader should take this out for production
                console.log("Initialising OsOpenNames");
                //add extra div with help message
                //Street name searching takes account of the current map view. If you can't find what you're looking for in this list, try zooming out or moving the map to cover the area where the street is located.
                _this._helpElement = $("<div id='OsOpenNames-help' style='display:none'><p>Street name searching takes account of the current map view. If you can't find what you're looking for in this list, try zooming out or moving the map to cover the area where the street is located.</p></div>")
                    .insertAfter(_this.resultsSelect);
                var self_1 = _this;
                $(".clearer").on("click", function () {
                    self_1._helpElement.hide();
                });
                _this.locationPinStyle = new Style_1.default({
                    text: new Text_1.default({
                        text: '\uf3c5',
                        font: 'normal 52px "Font Awesome 6 Pro"',
                        textBaseline: 'bottom',
                        fill: new Fill_1.default({
                            color: '#ff0000'
                        })
                    })
                });
                _this._osInitialised = true;
            }
        };
        _this.find = function (searchTerm) {
            var searchType = _this.getSearchType(searchTerm);
            if (searchTerm.trim() === "") {
                return;
            }
            _this._currentSearchTerm = searchTerm;
            //remove all existing entries      
            _this.resultsSelect.empty();
            _this.resultsSelect.hide();
            _this._helpElement.hide();
            _this.noResults.hide();
            _this.pointLayer.getSource().clear();
            switch (searchType) {
                case GazetteerSearchType_1.GazetteerSearchType.Postcode:
                    _this.findPostcode(searchTerm);
                    break;
                case GazetteerSearchType_1.GazetteerSearchType.Location:
                    _this.findAddressAndLocation(searchTerm);
                    break;
            }
        };
        _this.findPostcode = function (searchTerm) {
            var self = _this;
            var error = function (error) {
                self.loadingIndicator.hide();
                console.error(error);
            };
            var success = function (result) {
                var osResult = {
                    searchType: GazetteerSearchType_1.GazetteerSearchType.Postcode,
                    results: result.results
                };
                self.onSearchGazetteerResult(osResult);
            };
            var search = _this.searchGazetteer({
                url: _this._osNamesUrl,
                //key: "1D5aW6pbptU2bufc2DBAux8JYvtrbeon",
                key: self._apikey,
                query: searchTerm,
                maxResults: 20,
                fq: "LOCAL_TYPE:Postcode"
            });
            $.when(search)
                .then(success, error)
                .always(function () { self.loadingIndicator.hide(); });
        };
        _this.findAddressAndLocation = function (searchTerm) {
            var self = _this;
            var success = function (result1, result2) {
                var combinedResult = {
                    searchType: GazetteerSearchType_1.GazetteerSearchType.LocationAndAddressLine,
                    results: []
                };
                var data = result1[0];
                var res = [];
                if (data.results && data.results.length > 0) {
                    res = res.concat(data.results);
                }
                data = result2[0];
                if (data.results && data.results.length > 0) {
                    res = res.concat(data.results);
                }
                combinedResult.results = res;
                self.onSearchGazetteerResult(combinedResult);
            };
            var error = function (error) {
                self.loadingIndicator.hide();
                console.error(error);
            };
            $.when(_this.findLocation(searchTerm), _this.findAddress(searchTerm))
                .then(success, error)
                .always(function () { self.loadingIndicator.hide(); });
        };
        _this.findLocation = function (searchTerm) {
            return _this.searchGazetteer({
                url: _this._osNamesUrl,
                //key: "1D5aW6pbptU2bufc2DBAux8JYvtrbeon",
                key: _this._apikey,
                query: searchTerm,
                maxResults: 10,
                fq: "LOCAL_TYPE:City LOCAL_TYPE:Town LOCAL_TYPE:Hamlet LOCAL_TYPE:Other_Settlement LOCAL_TYPE:Village LOCAL_TYPE:Suburban_Area"
            });
        };
        _this.findAddress = function (searchTerm) {
            var extent = _this._mapBounds;
            var bounds = [extent[0].toFixed(2), extent[1].toFixed(2), extent[2].toFixed(2), extent[3].toFixed(2)];
            return _this.searchGazetteer({
                url: _this._osNamesUrl,
                //key: "1D5aW6pbptU2bufc2DBAux8JYvtrbeon",
                key: _this._apikey,
                query: searchTerm,
                maxResults: 10,
                fq: "LOCAL_TYPE:Named_Road",
                bounds: bounds.join(",")
            });
        };
        _this.searchGazetteer = function (params) {
            var self = _this;
            var url = params.url;
            delete params.url;
            self.loadingIndicator.show();
            return $.ajax({
                url: url,
                data: params,
                dataType: "json"
            });
        };
        _this.onSearchGazetteerResult = function (e) {
            if (e.results && e.results.length > 0) {
                //one or more matches
                _this.processSearchResult(e, _this._zoomToLevel);
            }
            else {
                _this.resultsSelect.empty();
                _this.resultsSelect.append("<option>".concat(_this._textPack.noResultsFound, "</option>"));
                _this.noResults.show();
            }
        };
        _this.processSearchResult = function (osResults, zoomToLevel) {
            var self = _this;
            var locations = new Array(), location;
            //remove all existing entries      
            self.resultsSelect.empty();
            self.resultsSelect.hide();
            self.noResults.hide();
            var mapExtent = self._map.options.extent;
            var getDescOrValue = function (g) {
                return (g.LOCAL_TYPE === "Postcode") ? g.NAME1 : "".concat(g.NAME1, ", ").concat((g.POPULATED_PLACE || g.DISTRICT_BOROUGH || g.COUNTY_UNITARY));
            };
            var getResultType = function (g) {
                return (g.LOCAL_TYPE === "Postcode") ? GazetteerSearchType_1.GazetteerSearchType.Postcode : (g.LOCAL_TYPE === "Named Road") ? GazetteerSearchType_1.GazetteerSearchType.AddressLine : GazetteerSearchType_1.GazetteerSearchType.Location;
            };
            var getDistance = function (g) {
                var coord = olProj.toLonLat([g.GEOMETRY_X, g.GEOMETRY_Y], "EPSG:27700");
                return self.getDistanceFromMapCenter([coord[0], coord[1]]);
            };
            //create the final results array
            for (var i = 0; i < osResults.results.length; i++) {
                var gazEntry = osResults.results[i]["GAZETTEER_ENTRY"];
                var coord = olProj.transform([gazEntry.GEOMETRY_X, gazEntry.GEOMETRY_Y], "EPSG:27700", self.displayProjection);
                if (olExtent.containsCoordinate(mapExtent, coord) === true) {
                    location = {
                        Easting: coord[0],
                        Northing: coord[1],
                        Name: getDescOrValue(gazEntry),
                        Value: getDescOrValue(gazEntry),
                        ZoomLevel: zoomToLevel,
                        ResultType: getResultType(gazEntry),
                        DistanceInMetres: getDistance(gazEntry)
                    };
                    locations.push(location);
                }
            }
            //sort by distance
            locations = locations.sort(function (a, b) {
                return (a.DistanceInMetres < b.DistanceInMetres) ? -1 : (a.DistanceInMetres > b.DistanceInMetres) ? 1 : 0;
            });
            //now add the distance to the name
            locations.forEach(function (location) {
                if (location.DistanceInMetres > 1000) {
                    location.Name += " (".concat((Math.round(location.DistanceInMetres / 1000 * 100) / 100).toFixed(0), " km)");
                }
                else if (location.DistanceInMetres > 200) {
                    location.Name += " (".concat((Math.round(location.DistanceInMetres * 100) / 100).toFixed(0), "m)");
                }
            });
            self.searchResults = new Array();
            if (locations.length === 0) {
                self.resultsSelect.append("<option>".concat(_this._textPack.noResultsFound, "</option>"));
                self.noResults.show();
            }
            else if (locations.length > 1) {
                //add empty option
                self.resultsSelect.append("<option>".concat(_this._textPack.selectFromResults, "</option>"));
                if (osResults.searchType === GazetteerSearchType_1.GazetteerSearchType.LocationAndAddressLine) {
                    //define 2 opts groups
                    var optStreet = $("<optgroup label='Road/street'></optgroup");
                    var optLocation = $("<optgroup label='Location'></optgroup");
                    for (var i = 0; i < locations.length; i++) {
                        if (locations[i].ResultType === GazetteerSearchType_1.GazetteerSearchType.AddressLine) {
                            optStreet.append("<option data-result-index=\"".concat(i, "\">").concat(locations[i].Name, "</option>"));
                        }
                        else {
                            optLocation.append("<option data-result-index=\"".concat(i, "\">").concat(locations[i].Name, "</option>"));
                        }
                        if (optLocation.children("option").length > 0) {
                            self.resultsSelect.append(optLocation);
                        }
                        if (optStreet.children("option").length > 0) {
                            self.resultsSelect.append(optStreet);
                        }
                        self.searchResults.push(locations[i]);
                    }
                }
                else {
                    //postcode               
                    for (var i = 0; i < locations.length; i++) {
                        if (locations[i].Value.replace(/ /g, '').toLowerCase() === _this._currentSearchTerm.replace(/ /g, '').toLowerCase()) {
                            //if the postcode matches exactly then go straight to it                      
                            self.addPinAndCenterMap([locations[i].Easting, locations[i].Northing], zoomToLevel);
                            return;
                        }
                        self.resultsSelect.append("<option data-result-index=\"".concat(i, "\">").concat(locations[i].Name, "</option>"));
                        self.searchResults.push(locations[i]);
                    }
                }
                self.resultsSelect.show();
                self._helpElement.show();
            }
            else if (locations.length === 1) {
                self.addPinAndCenterMap([locations[0].Easting, locations[0].Northing], zoomToLevel);
            }
        };
        _this.getSearchType = function (searchTerm) {
            //If the search term has numeric characters then assume it's postcode
            return (/\d/.test(searchTerm)) ? GazetteerSearchType_1.GazetteerSearchType.Postcode : GazetteerSearchType_1.GazetteerSearchType.Location;
        };
        _this.init();
        return _this;
    }
    return OsOpenNames;
}(GazetteerBase_1.GazetteerBase));
exports.OsOpenNames = OsOpenNames;
//# sourceMappingURL=OsOpenNames.js.map